import { EMPTY_ARRAY, IApplicationState, TCardId } from '../../../types/types';
import { ICollaborator } from '../../collaborators/collaborators/types';

export const getCardCollaborators = (
    state: IApplicationState,
    cardId: TCardId
): ICollaborator[] => {
    return state.modelsCollaborators.cards[cardId]||EMPTY_ARRAY;
};
